import { z } from 'zod';
import { OrganizationJSONSchema } from './organizations/organization';

export const SessionAccessJSONSchema = z.object({
	id: z.uuidv4(),
	organizations: z.array(OrganizationJSONSchema),
});

export type ISessionAccessJSON = z.infer<typeof SessionAccessJSONSchema>;
